// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_F13Vc","HeaderMobile":"HeaderMobile_g7+sy","Container":"Container_YvMCF","Title":"Title_0GE4u"};